import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../config/config";
import { SuperAdminState } from "../../types/types";
import { api_super_admin_routes } from "../../config/apiRoutes";

const initialState: SuperAdminState = {
  superadmin: [],
  loading: false,
  error: null,
};

export const getSuperAdmin = createAsyncThunk(
  "superadmin/get",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.GET(api_super_admin_routes.get);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch users");
    }
  }
);

export const createSuperAdmin = createAsyncThunk(
  "superadmin/create",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await API.POST(api_super_admin_routes.create, payload);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create"
      );
    }
  }
);
export const deleteSuperAdmin = createAsyncThunk(
  "superadmin/delete",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await API.DELETE(
        api_super_admin_routes.delete.replace(":id", id)
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete"
      );
    }
  }
);
export const updateSuperAdmin = createAsyncThunk(
  "superadmin/updateSuperAdmin",
  async ({ id, newData }: any, { rejectWithValue }) => {
    try {
      const response = await API.PUT(
        `${api_super_admin_routes.update.replace(":id", id)}`,
        newData
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data.error || error.message);
    }
  }
);
const superAdminSlice = createSlice({
  name: "superadmin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSuperAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSuperAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.superadmin = action.payload.data;
      })
      .addCase(getSuperAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed to load users";
      })
      .addCase(createSuperAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSuperAdmin.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createSuperAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed to create user";
      })
      .addCase(deleteSuperAdmin.fulfilled, (state, action) => {
        state.loading = false;
      });
  },
});

export default superAdminSlice.reducer;
